import React from "react"
import { TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import FakeVideosContent from "@assets/images/FakeVideosContent"

const IvehteTeam = () => {
    const videos = [
        {
            title: "Dr. Anne Dupont : diététicienne"
        },
        {
            title: "Albert Dupont : coach sportif"
        },
        {
            title: "Dr. Anne Dupont : médecin"
        }
    ]
    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.title} fontSize={RFValue(24)}>
                    L’équipe d’IVEHTE
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={RFValue(16)}>
                    Découvrez toute l’équipe d’IVEHTE !{" "}
                </OpenSansText>
            </View>

            <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                L’équipe d’IVEHTE est composée de plusieurs professionnels de santé : une diététicienne, un coach
                sportif, un cardiologue.{" "}
            </OpenSansText>

            <View style={styles.videos}>
                {videos.map((item, index) => (
                    <View key={index} style={styles.content}>
                        <BreeSerifText style={styles.missionLabel} fontSize={RFValue(20)}>
                            {item.title}
                        </BreeSerifText>
                        <TouchableOpacity activeOpacity={0.6} style={styles.videoContainer}>
                            <FakeVideosContent style={{ backgroundColor: baseColors.green.pastel }} />
                        </TouchableOpacity>
                    </View>
                ))}
            </View>
        </CustomScrollableContentWithBackHeader>
    )
}

export default IvehteTeam
